import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateDashboardFeedbackMutationVariables = Types.Exact<{
  comment: Types.Scalars['String']['input'];
}>;


export type CreateDashboardFeedbackMutation = { __typename?: 'Mutation', createDashboardFeedback: { __typename?: 'GenericMutationResult', success: boolean } };


export const CreateDashboardFeedbackDocument = gql`
    mutation createDashboardFeedback($comment: String!) {
  createDashboardFeedback(input: {comment: $comment}) {
    success
  }
}
    `;
export type CreateDashboardFeedbackMutationFn = Apollo.MutationFunction<CreateDashboardFeedbackMutation, CreateDashboardFeedbackMutationVariables>;

/**
 * __useCreateDashboardFeedbackMutation__
 *
 * To run a mutation, you first call `useCreateDashboardFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDashboardFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDashboardFeedbackMutation, { data, loading, error }] = useCreateDashboardFeedbackMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useCreateDashboardFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<CreateDashboardFeedbackMutation, CreateDashboardFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDashboardFeedbackMutation, CreateDashboardFeedbackMutationVariables>(CreateDashboardFeedbackDocument, options);
      }
export type CreateDashboardFeedbackMutationHookResult = ReturnType<typeof useCreateDashboardFeedbackMutation>;
export type CreateDashboardFeedbackMutationResult = Apollo.MutationResult<CreateDashboardFeedbackMutation>;
export type CreateDashboardFeedbackMutationOptions = Apollo.BaseMutationOptions<CreateDashboardFeedbackMutation, CreateDashboardFeedbackMutationVariables>;